import React from 'react';
import useAppSelector from '../app/redux/useAppSelector';
import Avatar from '../components/Avatar';
import Button from '../components/Button';
import apiIcon from '../icons/non-prefilled/16x16/api.svg';
import arrowLeft from '../icons/non-prefilled/16x16/arrowLeft.svg';
import auditIcon from '../icons/non-prefilled/16x16/audit.svg';
import authenticationIcon from '../icons/non-prefilled/16x16/authentication.svg';
import billingIcon from '../icons/non-prefilled/16x16/billing.svg';
import importExport from '../icons/non-prefilled/16x16/importExport.svg';
import integrationIcon from '../icons/non-prefilled/16x16/integration.svg';
import profileIcon from '../icons/non-prefilled/16x16/member.svg';
import notificationIcon from '../icons/non-prefilled/16x16/notifications.svg';
import provisionsIcon from '../icons/non-prefilled/16x16/provisions.svg';
import teamIcon from '../icons/non-prefilled/16x16/team.svg';
import TeamIcon from '../organization/TeamIcon';
import SettingsNavItem from './SettingsNavItem';
import * as styles from './SettingsSidebar.module.scss';

const SettingsSidebar = () => {
  const user = useAppSelector((state) => state.session.user);

  return (
    <>
      <div className={styles.section}>
        <Button className={styles.homeButton} to="/" icon={arrowLeft}>
          Exit Settings
        </Button>
        <h5>Me</h5>
        <SettingsNavItem
          icon={<Avatar user={user} size="small" />}
          to="/settings/profile"
        >
          Profile
        </SettingsNavItem>
        <SettingsNavItem icon={profileIcon} to="/settings" onlyActiveOnIndex>
          Account
        </SettingsNavItem>
        <SettingsNavItem icon={notificationIcon} to="/settings/notifications">
          Notifications
        </SettingsNavItem>
      </div>
      {user.type === 'ADMIN' && (
        <div className={styles.section}>
          <h5>My Team</h5>
          <SettingsNavItem
            icon={<TeamIcon size="small" />}
            to="/admin/appearance"
          >
            Appearance
          </SettingsNavItem>
          <SettingsNavItem icon={teamIcon} to="/admin/teammates">
            Teammates
          </SettingsNavItem>
          <SettingsNavItem icon={authenticationIcon} to="/admin/security">
            Security
          </SettingsNavItem>
          <SettingsNavItem icon={provisionsIcon} to="/admin/provisions">
            Provisions
          </SettingsNavItem>
          <SettingsNavItem icon={auditIcon} to="/admin/audit">
            Audit Logs
          </SettingsNavItem>
          <SettingsNavItem icon={integrationIcon} to="/admin/integrations">
            Integrations
          </SettingsNavItem>
          {/* <SettingsNavItem icon={betaIcon} to="/admin/beta">
            Beta features
          </SettingsNavItem> */}
          <SettingsNavItem icon={apiIcon} to="/admin/developer">
            Developer
          </SettingsNavItem>
          <SettingsNavItem icon={billingIcon} to="/admin/billing">
            Billing
          </SettingsNavItem>
          <SettingsNavItem icon={importExport} to="/admin/import">
            Import &amp; Export
          </SettingsNavItem>
        </div>
      )}
    </>
  );
};

export default SettingsSidebar;
